import { VkOrdHistoryResponse } from '@synapex/shared2/gateway-rest-api'

import cl from 'clsx'

import Diagram from '../../../../icons/stones/Diagram.svg?react'
import { MarkingPartLayout } from '../shared/MarkingPartLayout'
import { HISTORY_ITEM_STATUS } from './data'
import { EventsDialog, type EventsDialogProps } from './EventsDialog'
import classes from './OrdStatus.module.scss'

type SummaryProps = { lastItem: VkOrdHistoryResponse }
const Summary = ({ lastItem }: SummaryProps) => {
    const {
        errorMessage,
        lastUpdatedAt,
        lastUpdateStatus,
        externalId,
        typeText,
    } = lastItem

    const dateString = new Date(lastUpdatedAt).toLocaleString('ru-RU', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
    })

    const statusInfo = HISTORY_ITEM_STATUS[lastUpdateStatus]

    return (
        <div className={classes.summary}>
            <div className={classes.summaryTitle}>Последнее событие из ОРД</div>
            <div className={classes.summaryContent}>
                <div>{typeText}</div>
                <div>{dateString}</div>
                <div style={statusInfo.style}>{statusInfo.text}</div>
                <div>{errorMessage}</div>
                <div>{externalId ?? <hr />}</div>
            </div>
        </div>
    )
}

export type OrdStatusProps = Omit<EventsDialogProps, 'trigger'> & {
    flagStatus: boolean | 'error'
}
export const OrdStatus = ({ vkOrdHistory, flagStatus }: OrdStatusProps) => {
    return (
        <MarkingPartLayout
            title="Статус ОРД"
            tooltipContent={'События ORD'}
            Icon={Diagram}
            flagValue={flagStatus}
            checkboxLabel={'Статистика подана'}
            checkboxDisabled="Галочка о подаче статистики проставится автоматически"
            headerContent={
                <EventsDialog
                    trigger={
                        <div className={classes.dialogTrigger}>
                            <div className={classes.text}>
                                Смотреть всю историю
                            </div>
                            <div
                                className={cl(classes.count, {
                                    [classes.highlight]:
                                        vkOrdHistory.length > 0,
                                })}
                            >
                                {vkOrdHistory.length}
                            </div>
                        </div>
                    }
                    vkOrdHistory={vkOrdHistory}
                />
            }
            // checkboxDisabledMessage={checkboxDisabledMessage}
        >
            {vkOrdHistory.length > 0 ? (
                <Summary lastItem={vkOrdHistory[0]} />
            ) : (
                <div className={classes.summaryTitle}>Событий нет</div>
            )}
        </MarkingPartLayout>
    )
}
